import { Reducer } from 'redux';
import {
	IResourcesManagementActionTypes,
	IResourcesManagementState,
} from './Types';

const initialState: IResourcesManagementState = {
	aclResource: null,
	allACLResourcesTypes: [],
	allACLResourcesParents: [],
	allACLResources: [],
	loadingACLResources: true,
	isCreatingResource: false,
};

const reducer: Reducer<IResourcesManagementState> = (
	state = initialState,
	action
) => {
	switch (action.type) {
		case IResourcesManagementActionTypes.GET_ACL_RESOURCE_FAILED: {
			return {
				...state,
				aclResource: null,
				loadingACLResources: false,
			};
		}
		case IResourcesManagementActionTypes.GET_ACL_RESOURCE_SUCCEED: {
			return {
				...state,
				aclResource: action.payload,
				loadingACLResources: false,
			};
		}
		case IResourcesManagementActionTypes.GET_ACL_RESOURCES_FAILED: {
			return {
				...state,
				allACLResources: [],
				loadingACLResources: false,
			};
		}
		case IResourcesManagementActionTypes.GET_ACL_RESOURCES_SUCCEED: {
			return {
				...state,
				allACLResources: action.payload.Resources || [],
				loadingACLResources: false,
			};
		}
		case IResourcesManagementActionTypes.GET_ACL_RESOURCESPARENTS: {
			return {
				...state,
			};
		}
		case IResourcesManagementActionTypes.GET_ACL_RESOURCESPARENTS_FAILED: {
			return {
				...state,
			};
		}
		case IResourcesManagementActionTypes.GET_ACL_RESOURCESPARENTS_SUCCEED: {
			return {
				...state,
				allACLResourcesParents: action.payload.Resources || [],
			};
		}
		case IResourcesManagementActionTypes.GET_ACL_RESOURCESTYPES: {
			return {
				...state,
			};
		}
		case IResourcesManagementActionTypes.GET_ACL_RESOURCESTYPES_FAILED: {
			return {
				...state,
			};
		}
		case IResourcesManagementActionTypes.GET_ACL_RESOURCESTYPES_SUCCEED: {
			return {
				...state,
				allACLResourcesTypes: action.payload.Types || [],
			};
		}
		case IResourcesManagementActionTypes.SET_LOADING_ACLRESOURCES: {
			return {
				...state,
				loadingACLResources: action.payload,
			};
		}
		case IResourcesManagementActionTypes.EMPTY_LIST_ACL_RESOURCES: {
			return {
				...state,
				allACLResources: [],
			};
		}
		case IResourcesManagementActionTypes.SET_CREATING_RESOURCE: {
			return {
				...state,
				isCreatingResource: action.payload.isLoading,
			};
		}
		case IResourcesManagementActionTypes.DELETE_ACL_RESOURCE_SUCCEED: {
			return {
				...state,
				allACLResources: state.allACLResources.filter(
					resource => resource.id !== action.payload.id
				)
			};
		}
		case IResourcesManagementActionTypes.DELETE_ACL_RESOURCE_FAILED: {
			return {
				...state,
			};
		}
		case IResourcesManagementActionTypes.UPDATE_ACL_RESOURCE_SUCCEED: {
			return {
				...state,
				allACLResources: state.allACLResources.map(resource => 
					resource.id === action.payload.id 
						? { ...resource, ...action.payload.resource }
						: resource
				)
			};
		}
		case IResourcesManagementActionTypes.UPDATE_ACL_RESOURCE_FAILED: {
			return {
				...state,
			};
		}
		default: {
			return state;
		}
	}
};

export { reducer as ResourcesManagementReducer };
